
<template>
    <aside class="grid--side sub-nav">
        <ul class="sub-nav__list">
            <li
                class="sub-nav__item"
                v-for="{ name, children } in subNav"
                :key="`subnav-${name}`"
            >
                <a
                    :href="`#${name}`"
                    :class="['sub-nav__link', { 'sub-nav__link--active' : name.toLowerCase() === activeParent }]"
                    @click.prevent="scrollToAnchor(name)"
                >
                    {{ name | titleCase }}
                </a>

                <ul v-if="children" class="sub-nav__children" :key="`${name}-children-${children.length * Math.random()}`">
                    <li
                        class="sub-nav__item"
                        v-for="child in children"
                        :key="`subnav-child-${child.name}`"
                    >
                        <a
                            :href="`#${navPrefix}${convertKebabCase(child.name)}`"
                            :class="['sub-nav__link', { 'sub-nav__link--active' : convertKebabCase(child.name) == activeSubItem }]"
                            @click.prevent="scrollToAnchor(`${navPrefix}${convertKebabCase(child.name)}`)"
                        >
                            {{ child.name | titleCase }}
                        </a>
                    </li>
                </ul>
            </li>
        </ul>
    </aside>
</template>

<script>
import { kebabToTitle, toKebabCase } from '@/helpers'
import gsap from 'gsap'

export default {
    props: {
        subNav: { type: Array, required: true },
        navPrefix: { type: String},
        activeParent: { type: String, default: 'summary' },
        activeSubItem: { type: String, default: '' },
    },

    filters: {
        titleCase (val) {
            return kebabToTitle(val)
        },
    },

    methods: {
        convertKebabCase (val) {
            return toKebabCase(val)
        },

        scrollToAnchor (e) {
            const el = document.getElementById(`${e}`)
            gsap.to(window, {
                duration: .5,
                scrollTo: el.offsetTop - 30,
                ease: 'power2.easeOut'
            })
        }
    }
}
</script>
